// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  // Sin React.StrictMode para evitar dobles renders y “flashes”
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
